import React from "react";

export default function EmployeeRecords() {
  return (
    <div className="w-full h-screen text-center items-center justify-center flex">
      Thanks for submitting the form
    </div>
  );
}
